import Home from "../../Pages/Home";
import Work from "../../Pages/Work";
import About from "../../Pages/About";
import BottomBar from "../UI/BottomBar";
import Skills from "../../Pages/Skills";
import Socials from "../../Pages/Socials";
import TopNavigation from "../TopNavigation";
import Education from "../../Pages/Education";
import Portfolio from "../../Pages/Portfolio";

const ContentContainer = ({ pagename }) => {
  let content;
  switch (pagename) {
    case "Homepage":
      content = <Home />;
      break;
    case "About":
      content = <About />;
      break;
    case "Work Experience":
      content = <Work />;
      break;
    case "Education":
      content = <Education />;
      break;
    case "Skills":
      content = <Skills />;
      break;
    case "Some of my previous work":
      content = <Portfolio />;
      break;
    case "Get in touch":
      content = <Socials />;
      break;
    default:
      content = <Home />;
      break;
  }

  return (
    <div className="content-container">
      <TopNavigation pagename={pagename} />
      {content}
      {pagename === "Get in touch" && <BottomBar />}
    </div>
  );
};

export default ContentContainer;
